import { render, staticRenderFns } from "./FactoryOrderDetailsCard.vue?vue&type=template&id=14e45a00&scoped=true&"
import script from "./FactoryOrderDetailsCard.vue?vue&type=script&lang=ts&"
export * from "./FactoryOrderDetailsCard.vue?vue&type=script&lang=ts&"
import style0 from "./FactoryOrderDetailsCard.vue?vue&type=style&index=0&id=14e45a00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e45a00",
  null
  
)

export default component.exports